import { select, SelectEffect } from 'redux-saga/effects'
import { ReduxState } from '.'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

export function selectState<T>(selector: (s: ReduxState) => T): SelectEffect {
  return select(selector)
}

export const useTypedSelector: TypedUseSelectorHook<ReduxState> = useSelector
